import { useBILogger } from '@wix/fe-essentials/react';
import { useCallback, useMemo } from 'react';

const EVENT_ID = {
  ADDON_INSTALL_TRY: 105,
  ADDON_INSTALL_SUCCESS: 103,
  ADDON_UNINSTALL_TRY: 106,
  ADDON_UNINSTALL_SUCCESS: 107,
  ADDON_HOVER: 208,
};

export type BaseAddonEventPayload = {
  origin: 'addon_market_card' | 'addon_manage_card';
};

export type InstallAddonEventPayload = {
  host_app_id: string;
} & BaseAddonEventPayload;

export type UninstallAddonEventPayload = {
  host_app_id: string;
} & BaseAddonEventPayload;

export type HoverAddonEventPayload = {
  origin: 'addon_market_card' | 'addon_manage_card';
  action_context: string;
};

export const useBi = () => {
  const logger = useBILogger();

  const defaultAddonEvents = useMemo(
    () => ({
      target_type: 'addon',
    }),
    [],
  );

  const addonInstallTry = useCallback(
    (payload: InstallAddonEventPayload) => {
      logger.log({
        ...payload,
        ...defaultAddonEvents,
        role: 'user',
        evid: EVENT_ID.ADDON_INSTALL_TRY,
      });
    },
    [defaultAddonEvents, logger],
  );

  const addonInstallSuccess = useCallback(
    (payload: InstallAddonEventPayload) => {
      logger.log({
        ...payload,
        ...defaultAddonEvents,
        role: 'user',
        evid: EVENT_ID.ADDON_INSTALL_SUCCESS,
      });
    },
    [defaultAddonEvents, logger],
  );

  const addonUninstallTry = useCallback(
    (payload: UninstallAddonEventPayload) => {
      logger.log({
        ...payload,
        ...defaultAddonEvents,
        method: 'click',
        evid: EVENT_ID.ADDON_UNINSTALL_TRY,
      });
    },
    [defaultAddonEvents, logger],
  );

  const addonUninstallSuccess = useCallback(
    (payload: UninstallAddonEventPayload) => {
      logger.log({
        ...payload,
        ...defaultAddonEvents,
        method: 'click',
        evid: EVENT_ID.ADDON_UNINSTALL_SUCCESS,
      });
    },
    [defaultAddonEvents, logger],
  );

  const addonHover = useCallback(
    (payload: HoverAddonEventPayload) => {
      logger.log({
        ...payload,
        ...defaultAddonEvents,
        evid: EVENT_ID.ADDON_HOVER,
      });
    },
    [defaultAddonEvents, logger],
  );

  return {
    addonInstallTry,
    addonInstallSuccess,
    addonUninstallTry,
    addonUninstallSuccess,
    addonHover,
  };
};
